document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('reserve');
  if (modal) {
    // モーダル表示の必要性を確認
    if (!isModalShownToday()) {
      modal.classList.add("is-active");
    }

    // 'reserveCheck' フォーム内のチェックボックスに限定
    const checkboxes = document.querySelectorAll('#reserveCheck input[type="checkbox"]');
    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        const allChecked = Array.from(checkboxes).every(c => c.checked);
        document.querySelector('.js-closeModal').disabled = !allChecked;
      });
    });

    // 閉じるボタンのイベントリスナー
    document.querySelectorAll('.js-closeModal').forEach(function(button) {
      button.addEventListener('click', function(event) {
        const allChecked = Array.from(checkboxes).every(c => c.checked);
        if (!allChecked) {
          alert('すべての項目にチェックを入れてください');
          event.stopPropagation(); // モーダルが閉じるのを防ぐ
        } else {
          modal.classList.remove("is-active");
          recordModalShown();
        }
      });
    });

    // モーダルのオーバーレイをクリックしても閉じないようにする
    document.querySelector('.p-modal__overlay').addEventListener('click', function(event) {
      event.stopPropagation();
    });
  }
});

function isModalShownToday() {
  const shownDate = localStorage.getItem('modalShownDate');
  const currentDate = new Date().toDateString();
  return shownDate === currentDate;
}

function recordModalShown() {
  const currentDate = new Date().toDateString();
  localStorage.setItem('modalShownDate', currentDate);
}
